import { Injectable } from '@angular/core';

@Injectable()
export class Usuario
{
  public nombre: string = '';
  public apellido: string = '';
  public telefono: string = '';
  public direccion: string = '';
  public email: string = '';
  public usuario: string = '';
  public password: string = '';
  public idLocal: number = 0;
  public administrador: boolean = false;

  constructor() 
  { 
  }

  limpiarVariables()
  {
    this.nombre = '';
    this.apellido = '';
    this.telefono = '';
    this.direccion = '';
    this.email = '';
    this.usuario = '';
    this.password = '';
    this.idLocal = 0;
    this.administrador = false;
  }
}
